import { render } from "./DroppingPlace.vue?vue&type=template&id=61aea546&scoped=true"
import script from "./DroppingPlace.vue?vue&type=script&lang=js"
export * from "./DroppingPlace.vue?vue&type=script&lang=js"

import "./DroppingPlace.vue?vue&type=style&index=0&id=61aea546&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61aea546"]])

export default __exports__